<template>
  <div id="popUpWin">
    <div>
      <div class="cross" v-on:click="closePopUp">
        <cross-icon/>
      </div>
      <h1>Изменение личных данных</h1>

      <text-input :label="'E-mail'"/>
      <text-input :label="'Номер телефона'"/>
    </div>

    <div>
      <button class="whiteButton" v-on:click="closePopUp">Отменить</button>
      <button class="purpleButton">Сохранить</button>
    </div>
  </div>
</template>

<script>
import CrossIcon from '@/assets/svg/cross';
import TextInput from '@/components/Form/text-input';
export default {
  name: 'edit-profile',
  components: { TextInput, CrossIcon },
  methods: {
    closePopUp () {
      this.$store.commit('closePopUp');
    }
  }
};
</script>

<style scoped>
#popUpWin { height: calc(165.33vw - 10.67vw); display: flex; flex-direction: column; justify-content: space-between }
#popUpWin>div>h1 { margin-bottom: 4.27vw }
#popUpWin>div:last-child { display: flex; flex-direction: column }
#popUpWin>div:last-child>button { padding: 3.20vw 0 }
#popUpWin>div:last-child>button:first-child { margin-bottom: 2.13vw }
#popUpWin>div>.kariInput { margin-bottom: 5.33vw }
@media screen and (min-width: 760px) {}

@media screen and (min-width: 1200px) {
  #popUpWin { height: calc(433px - 40px); width: calc(600px - 40px) }
  #popUpWin>div>h1 { margin-bottom: 20px }
  #popUpWin>div:last-child { flex-direction: row; justify-content: space-between; }
  #popUpWin>div:last-child>button { padding: 16px 0; width: 276px }
  #popUpWin>div:last-child>button:first-child { margin-bottom: 0 }
  #popUpWin>div>.kariInput { margin-bottom: 16px }
  #popUpWin>div>.kariInput:last-child { margin-bottom: 34px }
}

</style>
